import React from "react"

interface ShipDataItemProps {
  namePrefix: string;
  id?: string | number;
  children: React.ReactNode;
}

export function ShipDataItem({ namePrefix, id, children }: ShipDataItemProps) {
  return (
    <>
      <input type="hidden" name={`${namePrefix}id`} defaultValue={id} />
      {children}
    </>
  );
}
